angular.module('bmsApp.user')
	.factory('SetupSvc', [
		'CRUDSvc',
		function (CRUDSvc) {
			function checkKey(key, type) {
				return CRUDSvc.post('api/setup/check-key', {
					key: key,
					type: type,
				});
			}

			function activate(params) {
				return CRUDSvc.post('api/setup/activate', params);
			}

			return {
				checkKey: checkKey,
				activate: activate
			};
		}
	]);
